import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_TASK } from "../task.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateTaskInput } from "../../../__generated__/globalTypes";
import {
  CreateTaskMutation,
  CreateTaskMutationVariables,
} from "../../../__generated__/CreateTaskMutation";

interface IProps {
  defaultValues: DeepPartial<CreateTaskInput>;
  onCompleted: () => any;
}

export const useCreateTask = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateTaskInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateTaskMutation,
    CreateTaskMutationVariables
  >(CREATE_TASK, {
    refetchQueries: ["TasksQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: {
            ...parseParams(input),
            description: input.description ?? "",
          },
        },
      });

      if (data?.createTask?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createTask?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
